import { RouteView, PageView } from '../layouts'
export const service = {
    path: '/service',
    name: 'service',
    component: PageView,
    meta: { title: '服务管理', icon: 'project', isMenuShow: true ,permission:'service'},
    children: [
        {
            path: '/service/content/reservationMaintenance',
            name: 'serReservation',
            component: () => import('../views/service/reservationMaintenance.vue'),
            meta: { title: '预约维保', keepAlive: false, isMenuShow: true ,permission:'service:reservation'},
        },
        {
            path: '/service/content/emergencyRescue',
            name: 'serEmergency',
            component: () => import('../views/service/emergencyRescue.vue'),
            meta: { title: '紧急救援', icon: 'dollar', isMenuShow: true ,permission:'service:rescue'},
        },
        {
            path: '/service/content/evaluationManagement',
            name: 'serManagement',
            component: PageView,
            redirect:'/service/content/evaluationManagement2',
            meta: { title: '评价管理', icon: 'dollar', isMenuShow: true ,permission:'service:evaluation'},
            children: [
                {
                    path: '/service/content/evaluationManagement2',
                    name: 'serManagement2',
                    component: () => import('../views/service/evaluationManagement.vue'),
                    meta: { title: '门店评价', keepAlive: false, isMenuShow: true ,permission:'service:evaluation:evaluate'},
                },
                {
                    path: '/service/content/evaluationList',
                    name: 'serEvaluationList',
                    component: () => import('../views/service/evaluationList.vue'),
                    meta: { title: '评价列表', icon: 'dollar', isMenuShow: true ,permission:'service:evaluation:evaluate:list'},
                },
            ]
        },
    ]
}
